// extracted by mini-css-extract-plugin
module.exports = {"title":"PageTitle_title__plAft","load":"PageTitle_load__eEU3j"};